export enum GeneratedDocumentItemStatus {
  Unspecified = 'unspecified',
  Queued = 'queued',
  Generating = 'generating',
  Ready = 'ready',
  Failed = 'failed',
}
